const aboveOverlayClass = "above-overlay"

const overlays = new Set()

class Overlay {
  isClosingTimer = null
  attachedElements = new Set()

  constructor(container = document.querySelector("#main-content")) {
    this.container = container
    this.overlay = document.createElement("div")
    this.overlay.innerHTML = "&nbsp;"
    this.overlay.classList.add("overlay")

    this.overlay.addEventListener("transitionend", (e) => {
      if (e.propertyName === "opacity" && !this.isOpen) {
        if (this.attachedElements && this.attachedElements.size) {
          this.attachedElements.forEach((element) => {
            this.detachElement(element)
          })
        }

        if (this.afterClosed) {
          this.afterClosed()
          this.afterClosed = null
        }

        this.detachOverlay()
      }

      if (e.propertyName === "opacity" && this.isOpen && this.afterOpened) {
        this.afterOpened()
        this.afterOpened = null
      }
    })

    overlays.add(this)
  }

  attachOverlay() {
    this.container.appendChild(this.overlay)
  }

  detachOverlay() {
    this.container.removeChild(this.overlay)
  }

  async open({ attachElements, afterOpened, beforeOpened } = {}) {
    await this.attachOverlay()

    if (this.isClosingTimer) {
      clearTimeout(this.isClosingTimer)
      this.isClosingTimer = null
    }

    if (beforeOpened) beforeOpened()

    if (attachElements) {
      attachElements.forEach((element) => {
        this.attachedElements.add(element)
      })

      this.attachedElements.forEach((element) => {
        element.classList.add(aboveOverlayClass)
      })
    }

    requestAnimationFrame(() => {
      this.overlay.classList.add("open")
    })

    if (afterOpened) this.afterOpened = afterOpened
  }

  close({ delay, beforeClosed, afterClosed } = {}) {
    if (beforeClosed) beforeClosed()

    this.afterClosed = afterClosed

    const closeOverlay = () => {
      requestAnimationFrame(() => {
        this.overlay.classList.remove("open")
      })
    }

    if (delay) {
      this.isClosingTimer = setTimeout(closeOverlay, delay)
      return
    }

    closeOverlay()
  }

  detachElement(element) {
    const isAttached = this.attachedElements.has(element)

    if (isAttached && element.classList.contains(aboveOverlayClass)) {
      element.classList.remove(aboveOverlayClass)
      this.attachedElements.delete(element)
    }
  }

  get isOpen() {
    return this.overlay.classList.contains("open")
  }

  onClick(callback = () => {}) {
    if (!callback) return

    this.overlay.addEventListener("click", callback)
  }

  removeOnClick(callback = () => {}) {
    if (!callback) return

    this.overlay.removeEventListener("click", callback)
  }

  onHover(callback = () => {}) {
    if (!callback) return

    this.overlay.addEventListener("mouseover", (e) => {
      if (this.isOpen) callback(e)
    })
  }
}

export default Overlay
